import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      extraDark: "#8c781a",
      dark: "#bb9f2f",
      main: "#eecb3d",
      light: "#f7df72",
      veryLight: "#fff6cc",
      contrastText: "#000000",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    // Yeh naya addition hai Paper ke liye
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16, // Paper ka default border radius 12px
        },
        rounded: {
          borderRadius: 16, // Agar koi Paper rounded prop use kare to bhi 12px
        },
        elevation1: {
          boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)", // Optional: softer shadow
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#eecb3d",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#eecb3d",
          },
        },
        notchedOutline: {
          borderRadius: 12,
          transition: "border-color 0.2s ease",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontSize: "18px",
          fontWeight: 500,
          padding: "8px 22px",
          color: "#FFFFFF",
          boxShadow: "none",
          transition:
            "background-color 0.2s ease-in-out, transform 0.1s ease-in-out",

          "&:hover": {
            backgroundColor: "#f7df72",
            boxShadow: "none",
          },

          "&:active": {
            backgroundColor: "#bb9f2f",
            transform: "scale(0.98)",
            boxShadow: "none",
          },

          "&:disabled": {
            backgroundColor: "#f0e4a6",
            color: "rgba(0, 0, 0, 0.5)",
          },
        },

        outlined: {
          borderColor: "rgba(0, 0, 0, 0.23)",
          color: "rgba(0, 0, 0, 0.40)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255)",
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    // Table components...
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "none",
          border: "1px solid rgba(224, 224, 224, 1)",
        },
      },
    },
    // Baqi sab same...
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "separate",
          borderSpacing: 0,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            borderBottom: "none",
            backgroundColor: "#f7df72",
          },
          "& .MuiTableCell-root:first-of-type": {
            borderTopLeftRadius: 12,
          },
          "& .MuiTableCell-root:last-of-type": {
            borderTopRightRadius: 12,
          },
        },
      },
    },
    MuiTableFooter: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            borderTop: "1px solid rgba(224, 224, 224, 1)",
            backgroundColor: "#fafafa",
          },
          "& .MuiTableCell-root:first-of-type": {
            borderBottomLeftRadius: 12,
          },
          "& .MuiTableCell-root:last-of-type": {
            borderBottomRightRadius: 12,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid rgba(224, 224, 224, 1)",
        },
        head: {
          fontWeight: 600,
          backgroundColor: "#f5f5f5",
        },
        footer: {
          fontWeight: 500,
          backgroundColor: "#fafafa",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: "1px solid rgba(224, 224, 224, 1)",
          "&:last-child": {
            borderBottomLeftRadius: 12,
            borderBottomRightRadius: 12,
          },
        },
      },
    },
  },
});

export function MuiThemeProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
